import React from "react";
import { FiAlertTriangle, FiCheckCircle, FiInfo } from "react-icons/fi";

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, block, tone = "default" }) => {
  if (!isOpen) return null;

  const toneIcon = {
    danger: <FiAlertTriangle className="text-2xl" style={{ color: "#ef4444" }} />,
    success: <FiCheckCircle className="text-2xl" style={{ color: "#10b981" }} />,
    warning: <FiAlertTriangle className="text-2xl" style={{ color: "#f59e0b" }} />,
    default: <FiInfo className="text-2xl" style={{ color: "#a855f7" }} />,
  }[tone] || <FiInfo className="text-2xl" style={{ color: "#a855f7" }} />;

  const confirmToneClass =
    tone === "danger" || tone === "warning" ? "btn-danger" : "btn-primary";

  return (
    <div
      className="modal-backdrop"
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-modal-title"
    >
      <div
        className="modal-dialog max-w-sm mx-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-7 flex flex-col items-center text-center">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
            style={{
              background:
                tone === "danger"
                  ? "linear-gradient(135deg, rgba(239,68,68,0.2), rgba(239,68,68,0.05))"
                  : tone === "success"
                  ? "linear-gradient(135deg, rgba(16,185,129,0.2), rgba(16,185,129,0.05))"
                  : tone === "warning"
                  ? "linear-gradient(135deg, rgba(245,158,11,0.2), rgba(245,158,11,0.05))"
                  : "linear-gradient(135deg, rgba(168,85,247,0.22), rgba(236,72,153,0.08))",
              border: `1px solid ${
                tone === "danger"
                  ? "rgba(239,68,68,0.3)"
                  : tone === "success"
                  ? "rgba(16,185,129,0.3)"
                  : tone === "warning"
                  ? "rgba(245,158,11,0.3)"
                  : "rgba(168,85,247,0.32)"
              }`,
              boxShadow:
                tone === "danger"
                  ? "0 0 24px rgba(239,68,68,0.15)"
                  : tone === "success"
                  ? "0 0 24px rgba(16,185,129,0.15)"
                  : tone === "warning"
                  ? "0 0 24px rgba(245,158,11,0.15)"
                  : "0 0 24px rgba(168,85,247,0.2)",
            }}
          >
            {toneIcon}
          </div>
          <h2
            id="confirm-modal-title"
            className="txt-h3 mb-2 text-center"
            style={{ fontSize: "1.1rem" }}
          >
            {title}
          </h2>
          <p className="txt-body mb-6 text-center max-w-xs">{message}</p>

          <div className="flex items-center justify-center gap-3 w-full">
            <button
              type="button"
              onClick={onCancel}
              className="btn btn-secondary flex-1"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`btn ${confirmToneClass} flex-1`}
            >
              {block || "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
